/*
 * @Author: yacai 1756496601@qq.com
 * @Date: 2023-11-30 14:24:01
 * @LastEditors: yacai 1756496601@qq.com
 * @LastEditTime: 2023-11-30 14:57:10
 * @FilePath: /fe_shiyan_baoming_guoji/src/plugins/axios.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
"use strict";

import Vue from "vue";
import axios from "axios";
import QS from "qs";
import { Message } from "element-ui";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  // baseURL: process.env.VUE_APP_ENV === 'product' ? 'https://prod-api.dbxiao.com' : (process.env.VUE_APP_ENV === 'test' ? 'https://api-test.dbxiao.cn' : '/')
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    console.log(config);
    if(!config?.headers?.params){
      if (config.method === "post") {
        config.url +=
          "/" + process.env.VUE_APP_TENANTID + "/" + process.env.VUE_APP_BATCHID;
      } else if (config.method === "get") {
        config.url =
          config.url.split("?")[0] +
          "/" +
          process.env.VUE_APP_TENANTID +
          "/" +
          process.env.VUE_APP_BATCHID +
          (config.url.split("?")[1] ? "?" + config.url.split("?")[1] : "");
        const params = QS.parse(config.url.split("?")[1]);
        params.timestamp = new Date().getTime();
        config.url = config.url.split("?")[0] + `?${QS.stringify(params)}`;
      }
    }
  
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    if (response.data.code === "1000000") {
      return response.data;
    } else {
      Message({
        type: "error",
        message: response.data.msg,
        showClose: true,
        duration: 5000
      });
      return response.data;
    }
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios;
      }
    },
    $axios: {
      get () {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
